import logo from "../../static/images/dawid_logo.svg";
import items, {datasetTransferProcessing10} from "./gdpr_items.js";
import {
    getAllSharedTo,
    getNamesForTransfersLoop,
    getNumberOfDatasets,
    getNumberOfParties,
    getPartyName,
    listOfTransferNotProcessing10Parties,
    listOfTransferProcessing101112Parties
} from "./gdpr_flow_utils.js";

const version = "0.0.2";
const id = 1;
const name = "GDPR";
const disclaimerText = {
    title: 'Use conditions',
    body: [
        'The website you are about to consult provides access to the Data Agreement Wizard (hereinafter, "DAWID") a software tool developed by ELIXIR-Luxembourg, an infrastructure hosted by the Luxembourg Centre for Systems Biomedicine (LCSB) at the University of Luxembourg, which aims to facilitate the computerized generation of draft data sharing agreements in biomedical research. ELIXIR-Luxembourg is the sole owner of all copyrights and all intellectual property rights of DAWID.',
        '**Draft data sharing agreements generated by DAWID reflect current standards often used in biomedical research but cannot be understood as constituting finalized legal agreements. All persons making use of DAWID acknowledge that they fully understand that any draft generated by the software tool constitutes a non-specific, generic example of a data sharing agreement and will need to be adapted to the specific intended purpose and should be verified by a qualified legal professional.**',
        'Neither DAWID nor any content thereof, including but not limited to draft contractual clauses, generated or otherwise available via the software tool, can be considered as constituting or providing legal advice. ELIXIR-Luxembourg is not a legal professional and does not provide any legal advice. Consulting a qualified legal professional when in doubt is highly recommended.',
        'Permission to use DAWID is hereby granted to any person complying with the terms of service (hereinafter, the "user"). Access to and use of DAWID is subject both to the user\'s acknowledgement of the present disclaimer and to the explicit agreement by the user of all terms of service under which DAWID is operating. (The terms of use under which DAWID is operating can be consulted [here](https://elixir-luxembourg.org/privacy/terms_of_use).)',

        'The use of the software tool is provided "as is", without warranty of any kind, express or implied, including but not limited to the warranties of merchantability, fitness for a specific purpose and noninfringement.',
        '**In no event shall ELIXIR-Luxembourg be liable towards any user or any third party for any claim, damages or other liability, whether in an action of contract, tort or otherwise, arising from, out of or in connection with any content of generated draft data sharing agreements, the software tool per se, the use or any other dealing of the software tool.**',
        '_When working with DAWID, please be aware that the data is not persisted by default. You will have' +
        ' to create a session or export your data to be able to pause and resume your work._']
};
const loopsDefinitions = {
    dataset_info_loop: {
        name: "Cohorts",
        allowPreliminary: true,
        namePreliminarySection: 'Cohort\'s details',
        getIterationName: function (globals, loopState, loopIndex) {
            return loopState[loop_index - 1]["datasetDetails"]["values"][0]
        },
        loopType: 'cohorts',
        hasMoreIterations: function (states) {
            return getNumberOfDatasets(states) > 1;
        }
    },
    parties_info_loop: {
        name: "Parties",
        allowPreliminary: true,
        namePreliminarySection: 'Party\'s details',
        getIterationName: function (globals, loopState, loop_index) {
            return loopState[loop_index - 1]["partyDetails"]["values"][1]
        },
        loopType: 'parties'
    },
    dataset_samples_use: {
        name: "Samples receivers",
        allowPreliminary: false,
        getIterationName: function (globals, loopState, loop_index, loops, itemsStates) {
            const nbParties = getNumberOfParties(itemsStates);
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            let samplesReceiversCount = 0;
            for (let i = 0; i < nbParties; i++) {
                const isSamplesReceivers = globals['SamplesReceivers'][datasetIndex][i];
                if (isSamplesReceivers === true) {
                    samplesReceiversCount++;
                    if (samplesReceiversCount === loop_index) {
                        return getPartyName(i, loops);
                    }
                }
            }
        },
        hasMoreIterations: function (states, globals, loops) {
            const nbParties = getNumberOfParties(states);
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            let samplesReceiversCount = 0;
            for (let i = 0; i < nbParties; i++) {
                if (globals['SamplesReceivers'][datasetIndex][i] === true) {
                    samplesReceiversCount++;
                }
            }
            return samplesReceiversCount > 1;
        },
        loopType: 'parties'
    },
    dataset_transfer_processing101112: {
        name: "Parties with secondary, external or international transfers",
        allowPreliminary: false,
        restoreVariables: function (globals) {
            globals['WhereEarlyTermination'] = 'dataset_transfer_processing101112';
        },
        getIterationName: function (globals, loopState, loopIndex, loops, itemStates) {
            let parties;
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            if (globals['WhereEarlyTermination'] === 'dataset_transfer_not_processing10') {
                parties = listOfTransferNotProcessing10Parties(globals, itemStates, datasetIndex);
            } else {
                parties = listOfTransferProcessing101112Parties(globals, itemStates)
            }
            const partyIndexI = parties[loopIndex - 1];
            return getPartyName(partyIndexI, loops);
        },
        hasMoreIterations: function (states, globals, loops) {
            return listOfTransferProcessing101112Parties(globals, states).length > 1;
        },
        loopType: 'parties'
    },
    dataset_transfer_not_processing10: {
        name: "Parties (primary sharing)",
        allowPreliminary: false,
        getIterationName: function (globals, loopState, loop_index, loops, itemStates) {
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            const parties = listOfTransferNotProcessing10Parties(globals, itemStates, datasetIndex);
            const partyIndex = parties[loop_index - 1];
            return getPartyName(partyIndex, loops);
        },
        restoreVariables: function (globals) {
            globals['WhereEarlyTermination'] = 'dataset_transfer_not_processing10';
        },
        hasMoreIterations: function (states, globals, loops) {
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            const nbDatasets = getNumberOfDatasets(states);
            const nbParties = getNumberOfParties(states);
            let simpleCase = false;
            if (nbDatasets === 1 && nbParties === 2) {
                if (globals['HasRole'][0]['P'] && globals['HasRole'][1]['R'] &&
                    !globals['HasRole'][0]['R'] && !globals['HasRole'][1]['P']) {
                    // data transfer from 0 to 1
                    simpleCase = true;
                }
                if (globals['HasRole'][1]['P'] && globals['HasRole'][1]['R'] &&
                    !globals['HasRole'][1]['R'] && !globals['HasRole'][0]['P']) {
                    // data transfer from 1 to 0
                    simpleCase = true;
                }
            }
            return !simpleCase && listOfTransferNotProcessing10Parties(globals, states, datasetIndex).length > 1;
        },
        loopType: 'parties'
    },
    transfer_not_processing10_to: {
        name: "Parties shared to",
        allowPreliminary: false,
        restoreVariables: function (globals) {
            globals['WhereEarlyTerminationInner'] = 'transfer_not_processing10_to';
        },
        getIterationName: function (globals, loopState, loop_index, loops, itemStates) {
            const {
                partyName,
            } = getNamesForTransfersLoop(loop_index, itemStates, globals, loops);
            return partyName;
        },
        hasMoreIterations: function (states, globals, loops) {
            const datasetIndex = loops['dataset_info_loop'].index - 1;
            const processingLoopName = "dataset_info_loop#" + globals['WhereEarlyTermination'] + '$' + loops['dataset_info_loop'].index;
            const parties = listOfTransferNotProcessing10Parties(globals, states, datasetIndex);
            let loop = loops[processingLoopName];
            const partiesIndex = loop !== undefined ? loop.index - 1 : 0;
            const partyIndexI = parties[partiesIndex];
            const selectedShareTo = getAllSharedTo(states, globals, partyIndexI, datasetIndex);
            return selectedShareTo.length > 1;
        },
        loopType: 'parties'
    },
    transfer_processing10_to: {
        name: "Parties shared to",
        allowPreliminary: false,
        restoreVariables: function (globals) {
            globals['WhereEarlyTerminationInner'] = 'transfer_processing10_to';
        },
        getIterationName: function (globals, loopState, loop_index, loops, itemStates) {
            const {
                partyName,
            } = getNamesForTransfersLoop(loop_index, itemStates, globals, loops);
            return partyName;
        },
        hasMoreIterations: function (states) {
            const selectedShareTo = states[datasetTransferProcessing10.id].values[0];
            return selectedShareTo.length > 1;
        },
        loopType: 'parties'
    }
};

const flow = {id, items, name, version, logo, disclaimerText, loopsDefinitions: loopsDefinitions, outputLabel: "contract"};
export default flow;
